import { useEffect, useState } from 'react'
import { create } from 'zustand'

export type ThemeMode = 'light' | 'dark' | 'system'

const KEY = 'xifan.admin.theme'
const DARK_MQ = '(prefers-color-scheme: dark)'

function readMode(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY)
    if (v === 'light' || v === 'dark' || v === 'system') return v
  } catch {
    /* noop */
  }
  return 'system'
}

interface ThemeState {
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: readMode(),
  setMode: (mode) => {
    try {
      localStorage.setItem(KEY, mode)
    } catch {
      /* noop */
    }
    set({ mode })
  },
}))

export function useEffectiveTheme(): 'light' | 'dark' {
  const mode = useThemeStore((s) => s.mode)
  const [systemDark, setSystemDark] = useState(() =>
    typeof window === 'undefined'
      ? false
      : window.matchMedia(DARK_MQ).matches,
  )
  useEffect(() => {
    if (typeof window === 'undefined') return
    const mq = window.matchMedia(DARK_MQ)
    const handler = (e: MediaQueryListEvent) => setSystemDark(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  if (mode === 'system') return systemDark ? 'dark' : 'light'
  return mode
}
